import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import CalendarPage from "@/components/user/calendar/calendar-page";
import { requireFeature } from "@/lib/feature-gate";

export const Route = createFileRoute("/user/_layout/calendar")({
  beforeLoad: () => requireFeature("attendance"),
  validateSearch: z.object({
    tab: z.string().min(1).catch("general").default("general"),
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { tab } = Route.useSearch();
  return <CalendarPage activeTab={tab} />;
}
